/* eslint-disable @next/next/no-img-element */
import { useEffect, useState } from "react";

export default function TinyiFrameMobile({ data, frameId }) {
  const [value, setValue] = useState();

  useEffect(() => {
    try {
      if (data) {
        setValue(`<!DOCTYPE html>
          <html lang="en">
          <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Document</title>
            <link rel="stylesheet" href="/styles/tinymce.css"> <!-- Your TinyMCE CSS Link -->
            <!-- Include any other styles specific to your content -->
          </head>
          <body>
            ${JSON.parse(data)}
          </body>
          </html>`);
        // setContentSrcDoc(contentWithStyles);
      }
    } catch (error) {
      setValue(`<!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Document</title>
        <link rel="stylesheet" href="/styles/tinymce.css"> <!-- Your TinyMCE CSS Link -->
        <!-- Include any other styles specific to your content -->
      </head>
      <body>
      <p className="text-mobile sm:text-sm 2xl:text-base text-gray-900 font-medium mt-1 leading-5">
      ${data}
    </p>
      </body>
      </html>`);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <div className="w-full" style={{ height: `600px` }}>
      {value && (
        <iframe
          id={frameId}
          srcDoc={value}
          style={{ width: "100%", height: "100%", border: "none" }}
          sandbox="allow-same-origin"
        ></iframe>
      )}
    </div>
  );
}
